module.exports = __webpack_public_path__ + "img/magazine@2x.b2f60db.jpg";